/** Date helpers shared across trip/point screens. */

export function parseDate(value: string | null | undefined): Date | null {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

/** Inclusive day count between two ISO dates, min 1. */
export function tripDayCount(start: string | null, end: string | null): number {
  if (!start || !end) return 1
  const s = Date.parse(`${start.slice(0, 10)}T12:00:00Z`)
  const e = Date.parse(`${end.slice(0, 10)}T12:00:00Z`)
  if (!Number.isFinite(s) || !Number.isFinite(e)) return 1
  const ms = e - s
  return Math.max(1, Math.round(ms / 86_400_000) + 1)
}

export function formatDateRange(start: string | null, end: string | null): string {
  const s = parseDate(start)
  const e = parseDate(end)
  if (!s && !e) return 'Dates not set'
  const opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' }
  if (s && e) {
    const sameYear = s.getFullYear() === e.getFullYear()
    const startStr = s.toLocaleDateString('en-US', opts)
    const endStr = e.toLocaleDateString('en-US', { ...opts, year: 'numeric' })
    return sameYear ? `${startStr} – ${endStr}` : `${s.toLocaleDateString('en-US', { ...opts, year: 'numeric' })} – ${endStr}`
  }
  const only = (s ?? e)!
  return only.toLocaleDateString('en-US', { ...opts, year: 'numeric' })
}

export function addDays(iso: string, days: number): string {
  const d = new Date(`${iso.slice(0, 10)}T12:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

export function localDateIso(date: Date, zone?: string): string {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone || 'Etc/UTC',
    year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date)
  const value = (name: string) => parts.find(p => p.type === name)?.value ?? ''
  return `${value('year')}-${value('month')}-${value('day')}`
}
